import AccountingPosa from './AccountingPosa';

export default AccountingPosa;
